import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Division from 'components/common/Division';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import HBox from 'components/common/HBox';
import * as Signals from 'modules/Signals';
import React from 'react';
import Check from 'components/common/Check';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

export default function SimulationDietTable(props) {
  const {
    renderAll,
    front,
    ...rest
  } = props;

  const [data, setData] = Recoil.useRecoilState(AppStore.assets.sim_meal);
  const onData = React.useCallback((data) => {
    setData(() => data);
  }, [setData]);
  Signals.useSlot('diet_data', onData);

  const [show1, setOnly1] = Recoil.useRecoilState(AppStore.assets.show1);
  const [std_food_name, setStdFoodName] = Recoil.useRecoilState(AppStore.assets.std_food_name);
  const [cp_food_names, setCpFoodNames] = Recoil.useRecoilState(AppStore.assets.cp_food_names);

  const onToggle = React.useCallback((e) => {
    setStdFoodName(() => '');
    setCpFoodNames(() => ['', '', '']);
    setOnly1(o => !o);
  }, [setCpFoodNames, setOnly1, setStdFoodName]);

  const {
    high_bldsugr_list = [],
    low_bldsugr_list = [],
  } = data || {};
  return (
    <HBox full {...ex('SimulationDietTable', rest)}>
      <Division full {...{ direction: DIRECTION_VERTICAL }}>
        <div>
          {T('혈당상승폭 높은 순서')}
        </div>
        <table>
          <thead>
            <tr>
              <th>
                <div>
                  {T('대표음식명')}
                </div>
              </th>
              <th>
                <div>
                  {T('기록')}
                </div>
              </th>
              <th>
                <div>
                  {T('혈당 상승폭')}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {high_bldsugr_list.map((item, index) => {
              const {
                food_name,
                intake_cnt,
                bldsugr_rise_w,
              } = item;
              if (!show1 && intake_cnt < 2) return null;
              const std = std_food_name === food_name;
              const cp = cp_food_names.includes(food_name);
              return (
                <tr key={index} {...ex({ std, cp })}>
                  <td>
                    <div>
                      {food_name}{/*  */}
                    </div>
                  </td>
                  <td>
                    <div>
                      {intake_cnt}
                    </div>
                  </td>
                  <td>
                    <div>
                      {bldsugr_rise_w ?? '-'}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Division>

      <Division full {...{ direction: DIRECTION_VERTICAL }}>
        {T('혈당상승폭 낮은 순서')}
        <table>
          <thead>
            <tr>
              <th>
                <div>
                  {T('대표음식명')}
                </div>
              </th>
              <th>
                <div>
                  {T('기록')}
                </div>
              </th>
              <th>
                <div>
                  {T('혈당 상승폭')}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {low_bldsugr_list.map((item, index) => {
              const {
                food_name,
                intake_cnt,
                bldsugr_rise_w,
              } = item;
              if (!show1 && intake_cnt < 2) return null;
              const std = std_food_name === food_name;
              const cp = cp_food_names.includes(food_name);
              return (
                <tr key={index} {...ex({ std, cp })}>
                  <td>
                    <div>
                      {food_name}{/*  */}
                    </div>
                  </td>
                  <td>
                    <div>
                      {intake_cnt}
                    </div>
                  </td>
                  <td>
                    <div>
                      {bldsugr_rise_w ?? '-'}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Division>

      <Check
        {...{
          checked: show1,
          onClick: onToggle,
        }}
      >
        {T('1회 나타내기')}
      </Check>
    </HBox>
  );
}
